import { defineMessage } from 'services/localization';

export const messages = {
    billColumnName: defineMessage('bill'),
    dateColumnName: defineMessage('date'),
    accountColumnName: defineMessage('category'),
    descriptionColumnName: defineMessage('description'),
    amountColumnName: defineMessage('amount_currency_2'),
    remainingColumnName: defineMessage('remaining_currency'),
    taxColumnName: defineMessage('tax'),
    customerColumnName: defineMessage('customer'),
    classColumnName: defineMessage('class'),
    billableColumnName: defineMessage('billable'),
    taxableColumnName: defineMessage('tax'),
    billableColumnTooltip: defineMessage('this_line_is_billable'),
    taxableColumnTooltip: defineMessage('this_line_is_taxable'),
    itemColumnName: defineMessage('productservice'),
    qtyColumnName: defineMessage('qty'),
    unitPriceColumnName: defineMessage('rate'),
    date: defineMessage('date_bdateb'),
    totalAmount: defineMessage('total_amount_totalamount'),
    matchLines: defineMessage('match_lines'),
    matchTooltip: defineMessage('match'),
};
